import BaseModel from "../core/BaseModel";
export default class CourseModel extends BaseModel {
  constructor() {
    super(
      {
        name: "course",
        tableName: "course",
        label: "Quản lý khóa đào tạo",
        display_key: "name",
        default_order: { key: "created_at", direction: "asc" },
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: { 
          name: 'id', 
          type: "Uuid", 
          label: 'ID', 
          primaryKey: true,
          display: false
        },
        avatar : {
          name: 'avatar', 
          type: "Image", 
          label: 'Ảnh',
        },
        name: {
          name: 'name',
          type: "TEXT",
          label: 'Tên khóa học',
          sortable: false,
          // width: 20,
          filter: {type: 'input',match: 'contains'}
        },
        type: {
          name: "type",
          label: "Loại",
          type: "Selection",
          custom: "SelectionText",
          class: "center",
          width: 6,
          options: [
            { value: 'online', label: "Online" },
            { value: 'offline', label: "Offline" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        active : {
          name: 'active', 
          type: "Selection", 
          custom: 'SelectionText',
          label: 'Hiển thị',
          class: 'center',
          width: 6,
          options: [
            {label: "Hiển thị",value: true},
            {label: "Ẩn",value: false}
          ],
          filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
        },
        updated_by : {
          name: 'updated_by', 
          type: "TEXT", 
          label: 'Người cập nhật',
          width : 10,
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối",
          width : 10,
          // filter: { type: "DateRange", match: "contains" },
        },
        created_at: {
          name: "created_at",
          type: "Datetime",
          label: "Ngày tạo",
          filter: { type: "DateRange", match: "contains" },
          display: false,
        }
      }
    );
  }
}
